var map = {
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./en_old.json": "9a78",
	"./es.json": "a306",
	"./old_de.json": "4369",
	"./pl.json": "89b2",
	"./zh-CHS.json": "7522",
	"./zh-CHT.json": "9d3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";